export { default as ContentfulSplitTout } from  './contentfulSplitTout'
export { default as ContentfulTout } from './contentfulTout'



// WEBPACK FOOTER //
// ./src/modules/contentful/touts/index.js